import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ConsolidatedExamResult, ExamResult } from '../../models/student-history-dashboard';
import * as d3 from "d3";

@Component({
  selector: 'app-history-graph',
  templateUrl: './history-graph.component.html',
  styleUrls: ['./history-graph.component.scss']
})
export class HistoryGraphComponent implements OnInit {

  constructor() { }
  @Input() width: number;
  @Input() height: number;
  @Input() paddingLeft: number = 5;
  @Input() paddingRight: number = 5;
  @Input() paddingTop: number = 5;
  @Input() paddingBottom: number = 5;
  @Input() circleRadius: number = 4;
  @Input() examSummary: Array<ConsolidatedExamResult>;
  @ViewChild('graph', { static: true }) svg: ElementRef;
  examWiseMarks: Array<ExamResult> = [];

  ngOnInit() {
    this.examSummary.forEach(o => {
      o.exam_results.forEach(exam => {
        this.examWiseMarks.push(exam);
      })
    });
    this.drawGraph();
  }

  drawGraph() {
    var x = d3.scaleLinear().range([this.paddingLeft, this.width - this.paddingRight])
      .domain([0, d3.max(this.examWiseMarks, function (d, i) { return i; })]);
    var y = d3.scaleLinear().range([this.height - 5, this.paddingTop])
      .domain([0, 100]);
    var x2 = d3.scaleLinear().range([this.paddingLeft, this.width - this.paddingRight])
      .domain(x.domain());

    var avgBezierLine = d3.line()
      .x(function (d, i) { return x(i); })
      .y(function (d: any) { return y(d.class_average); })
      .curve(d3.curveCatmullRom);

    var topperBezierLine = d3.line()
      .x(function (d, i) { return x(i); })
      .y(function (d: any) { return y(d.class_topper); })
      .curve(d3.curveCatmullRom);

    var examBezierLine = d3.line()
      .x(function (d, i) { return x(i); })
      .y(function (d: any) { return y(d.total_percentage); })
      .curve(d3.curveCatmullRom);

    var exams = this.examWiseMarks;
    var h = this.height;
    var exam_summary = this.examSummary;
    var zoomFunction = function () {
      var t = d3.event.transform;
      x.domain(t.rescaleX(x2).domain());
      avgPath.attr("d", avgBezierLine(exams));
      topperPath.attr("d", topperBezierLine(exams));
      marksPath.attr("d", examBezierLine(exams));
      avgCircle.attr("cx", function (d, i) { return x(i); });
      topperCircle.attr("cx", function (d, i) { return x(i); });
      marksCircle.attr("cx", function (d, i) { return x(i); });
      axisTicks.attr("transform", (d: any, i) => { return "translate(" + (x(i)) + "," + (h + 10) + ")"; });
      xAxis.attr("x1", x(0))
        .attr("x2", x(exams.length - 1));
      classGroup.attr("transform", (d: any, i) => {
        var length = i == 0 ? 1 : 0;
        for (var j = 0; j < i; j++) {
          length += exam_summary[j].exam_results.length;
        }
        return "translate(" + (x(length - 1)) + ",0)";
      });
      // classBoxRect.attr("width", (d: any, i) => {
      //   return x(d.exam_results.length) - x(0);
      // });
      classText.attr("transform", (d: any, i) => {
        var translateX = i == 0 ? ((x(d.exam_results.length - 1) - x(0)) / 2) : ((x(d.exam_results.length) - x(0)) / 2);
        return "translate(" + translateX + "," + (y(100) - 25) + ")";
      });
      classBoarder.attr("transform", (d: any, i) => {
        var translateX = i == 0 ? (x(d.exam_results.length - 1) - x(0)) : (x(d.exam_results.length) - x(0));
        return "translate(" + translateX + ",0)"
      });
    }

    var zoom = d3.zoom()
      .scaleExtent([1, 5])
      .translateExtent([[0, 0], [this.width, this.height]])
      .extent([[0, 0], [this.width, this.height]])
      .on("zoom", zoomFunction);

    var svg = d3.select(this.svg.nativeElement)
      .append("svg")
      .call(zoom)
      .attr("viewBox", "0 0 " + this.width + " " + (this.height + 100));

    var toolTip = d3.select("body")
      .select("#tooltipDiv");

    var classGroup = svg.append("g")
      .selectAll("g")
      .data(this.examSummary)
      .enter()
      .append("g")
      .attr("transform", (d: any, i) => {
        var length = i == 0 ? 1 : 0;
        for (var j = 0; j < i; j++) {
          length += this.examSummary[j].exam_results.length;
        }
        return "translate(" + (x(length - 1)) + ",0)";
      });

    // var classBoxRect = classGroup.append("rect")
    //   .attr("x", 0)
    //   .attr("y", 0)
    //   .attr("height", this.height + 100)
    //   .attr("width", (d: any, i) => {
    //     return x(d.exam_results.length) - x(0);
    //   })
    //   .attr("fill", (d, i) => {
    //     if (i % 2 == 0) {
    //       return "#e5e5e5";
    //     }
    //     else {
    //       return "#f9f9f9"
    //     }
    //   });

    var classBoarder = classGroup.append("line")
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", 0)
      .attr("y2", y(0) + 5)
      .attr("class", (d: any, i) => {
        if (i != this.examSummary.length - 1) {
          return "gline"
        }
      })
      .attr("transform", (d: any, i) => {
        var translateX = i == 0 ? (x(d.exam_results.length - 1) - x(0)) : (x(d.exam_results.length) - x(0));
        return "translate(" + translateX + ",0)"
      });

    var classText = classGroup.append("text")
      .text((d: any) => "Class " + d.class_name)
      .attr("class", "class-title")
      .style("text-anchor", "middle")
      .attr("transform", (d: any, i) => {
        var translateX = i == 0 ? ((x(d.exam_results.length - 1) - x(0)) / 2) : ((x(d.exam_results.length) - x(0)) / 2);
        return "translate(" + translateX + "," + (y(100) - 25) + ")";
      });

    var avgPath = svg.append('path')
      .attr("d", avgBezierLine(this.examWiseMarks))
      .attr("stroke", "#bdc1d4")
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "2, 2")
      .attr("fill", "none");

    var topperPath = svg.append('path')
      .attr("d", topperBezierLine(this.examWiseMarks))
      .attr("stroke", "rgba(241, 205, 124, 0.9)")
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "2, 2")
      .attr("fill", "none");

    var marksPath = svg.append('path')
      .attr("d", examBezierLine(this.examWiseMarks))
      .attr("stroke", "#535aff")
      .attr("stroke-width", 1)
      .attr("fill", "none")
      .attr("class", "studentPath");


    var avgCircle = svg.append("g")
      .selectAll("circle")
      .data(this.examWiseMarks)
      .enter()
      .append("circle")
      .attr("r", this.circleRadius)
      .attr("cx", function (d, i) { return x(i); })
      .attr("cy", function (d: any) { return y(d.class_average); })
      .attr("fill", "#bdc1d4")
      .on("mouseover", function (d: any) {
        toolTip.transition()
          .duration(200)
          .style("opacity", 1);
        toolTip.html(
          "<p>Class Avg</p>" +
          "<strong>" + (Math.round(d.class_average * 100) / 100).toString() + "%" + "</strong>" +
          "<p>" + d.examination_name + "</p>"
        )
          .style("left", (d3.event.pageX) + "px")
          .style("top", (d3.event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        toolTip.transition()
          .duration(500)
          .style("opacity", 0);
      });

    var topperCircle = svg.append("g")
      .selectAll("circle")
      .data(this.examWiseMarks)
      .enter()
      .append("circle")
      .attr("r", this.circleRadius)
      .attr("cx", function (d, i) { return x(i); })
      .attr("cy", function (d: any) { return y(d.class_topper); })
      .attr("fill", "rgba(241, 205, 124, 0.9)")
      .on("mouseover", function (d: any) {
        toolTip.transition()
          .duration(200)
          .style("opacity", .9);
        toolTip.html(
          "<p>Topper</p>" +
          "<strong>" + (Math.round(d.class_topper * 100) / 100).toString() + "%" + "</strong>" +
          "<p>" + d.examination_name + "</p>")
          .style("left", (d3.event.pageX) + "px")
          .style("top", (d3.event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        toolTip.transition()
          .duration(500)
          .style("opacity", 0);
      });

    var marksCircle = svg.append("g")
      .selectAll("circle")
      .data(this.examWiseMarks)
      .enter()
      .append("circle")
      .attr("r", this.circleRadius)
      .attr("cx", function (d, i) { return x(i); })
      .attr("cy", function (d: any) { return y(d.total_percentage); })
      .attr("fill", "#ffffff")
      .attr("stroke", "#535aff")
      .attr("stroke-width", "1")
      .on("mouseover", function (d: any) {
        toolTip.transition()
          .duration(200)
          .style("opacity", .9);
        toolTip.html(
          "<strong>" + (Math.round(d.total_percentage * 100) / 100).toString() + "%" + "</strong>" +
          "<p>" + d.examination_name + "</p>")
          .style("left", (d3.event.pageX) + "px")
          .style("top", (d3.event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        toolTip.transition()
          .duration(500)
          .style("opacity", 0);
      });


    var axisTicks = svg.append("g")
      .selectAll("g")
      .data(this.examWiseMarks)
      .enter()
      .append("g")
      .attr("transform", (d: any, i: any) => { return "translate(" + (x(i)) + "," + (this.height + 10) + ")"; });

    var axisText = axisTicks.append("text")
      .text((d: any) => d.examination_name)
      .style('fill', 'black')
      .attr("font-size", "8px")
      .style("alignment-baseline", "middle")
      .style("text-anchor", "end")
      .attr("transform", "rotate(-65)");

    var axisTick = axisTicks.append("line")
      .attr("x1", 0)
      .attr("y1", -10)
      .attr("x2", 0)
      .attr("y2", -5)
      .attr("class", "gline");

    var xAxis = svg.append("g")
      .append("line")
      .attr("x1", x(0))
      .attr("y1", this.height)
      .attr("x2", x(this.examWiseMarks.length - 1))
      .attr("y2", this.height)
      .attr("class", "gline");
  }
}
